import { Divider } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { openReleaseModal } from 'modules/releases/actions/release-modal';
import { getDisplayableReleases } from 'modules/releases/selectors/release-modal';
import { openReportIssueModal } from 'modules/reportIssues/actions';
import { getCurrentUserAdditionalData } from 'modules/users/selectors/currentUser';

import { WrapperContent, PopoverContent, PopoverFooter, IconHeart } from './UI';
/**
 * @typedef {{
 *  name: string,
 *  setOpen: (value: boolean) => void
 * }} HelpContentProps
 */

/** @type {React.FC<HelpContentProps>} */
const HelpContent = ({ name, setOpen }) => {
  const dispatch = useDispatch();
  const user = useSelector(getCurrentUserAdditionalData);

  const releases = useSelector(getDisplayableReleases);

  const displayReportIssue = user !== undefined;

  const handleReportIssue = React.useCallback(() => {
    dispatch(openReportIssueModal());
    setOpen(false);
  }, [dispatch, setOpen]);

  const handleReleaseNotes = React.useCallback(() => {
    dispatch(openReleaseModal(releases[0].id));
    setOpen(false);
  }, [dispatch, releases, setOpen]);

  return (
    <WrapperContent>
      <PopoverContent>
        <FormattedMessage id="about.needAssistance" defaultMessage="Need Assistance?" tagName="h3" />
        <p>
          <FormattedMessage id="about.contactUs" defaultMessage="Contact us by the following means." />
          <br />
          <FormattedMessage id="about.openingTime" defaultMessage="Mo-Fr from 9am to 5pm." tagName="b" />
        </p>
        <nav>
          <ul>
            {displayReportIssue && <li>
              <a className="header-usernav__help--link" onClick={handleReportIssue}>
                <span className="fb-icon fb-icon--report mr-3" />
                <FormattedMessage id="about.reportIssue" defaultMessage="Submit a request" />
              </a>
            </li>}
            <li>
              <a className="header-usernav__help--link" href="tel:+3228080828">
                <span className="fb-icon fb-icon--phone" /> +32 2 80 80 828
              </a>
            </li>
          </ul>
        </nav>
        {releases.length > 0 && (
          <>
            <Divider />
            <FormattedMessage id="about.releaseNotes" defaultMessage="Release notes" tagName="strong" />
            <nav className="mt-3">
              <ul>
                <li>
                  <a className="header-usernav__help--link" onClick={handleReleaseNotes} data-cy="open-release-notes">
                    <span className="fb-icon fb-icon--info mr-3" />
                    <FormattedMessage id="about.whatsNew" defaultMessage="What's new?" />
                  </a>
                </li>
              </ul>
            </nav>
          </>
        )}
      </PopoverContent>
      <PopoverFooter>
        <p>
          <a
            className="header-usernav__help--link d-flex align-items-center"
            href="https://www.fleetback.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="about.madeWith" defaultMessage="Made with" />
            <span className={classNames(IconHeart, 'fb-icon--heart text-base')} />{' '}
            <FormattedMessage id="about.byFleetback" defaultMessage="by {name}" values={{ name }} />
          </a>
        </p>
      </PopoverFooter>
    </WrapperContent>
  );
};

export default HelpContent;
